import React from 'react';
import classNames from 'classnames';

export interface FooterColumnItem {
  title: React.ReactNode;
  url?: string;
  openExternal?: boolean;
  icon?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  LinkComponent?: React.ReactType;
}

export interface FooterColumn {
  prefixCls?: string;
  title?: React.ReactNode;
  icon?: React.ReactNode;
  items?: FooterColumnItem[];
  className?: string;
  style?: React.CSSProperties;
}

const Column = ({ prefixCls, icon, title, items = [], style, className }: FooterColumn) => {
  return (
    <div className={classNames(`${prefixCls}-column`, className)} style={style}>
      {(title || icon) && (
        <h2 className={`${prefixCls}-column-title`}>
          {icon && <span className={`${prefixCls}-column-icon`}>{icon}</span>}
          {title}
        </h2>
      )}
      <ul className={`${prefixCls}-list`}>
        {items.map((item, i) => {
          const LinkComponent = item.LinkComponent || 'a';
          return (
            <li className={classNames(`${prefixCls}-item`, item.className)} style={item.style} key={i}>
              <LinkComponent
                href={item.url}
                to={typeof LinkComponent !== 'string' ? item.url : undefined}
                className={typeof item.title === 'string' ? `${item.title.toLowerCase()}_redirect_link` : ''}
                target={item.openExternal ? '_blank' : undefined}
                rel={item.openExternal ? 'noopener noreferrer' : undefined}
              >
                {item.icon && <span className={classNames(`${prefixCls}-item-icon`, 'no-click')}>{item.icon}</span>}
                <span className="no-click">{item.title}</span>
              </LinkComponent>
              {item.description && (
                <>
                  <span className={`${prefixCls}-item-separator`}>-</span>
                  <span className={`${prefixCls}-item-description`}>{item.description}</span>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Column;
